import type { ComponentType } from 'react';
import { createRegistry } from '../lib/registry';

/**
 * App-header slots (outside the editor), e.g. the notifications bell:
 *
 *   import { headerRegistry } from '../shell/slots';
 *   headerRegistry.register({ id: 'notifications', order: 10, component: NotificationsBell });
 *
 * The id 'notifications' is pre-registered with a disabled placeholder bell.
 */
export interface HeaderSlot {
  id: string;
  order?: number;
  component: ComponentType;
}

export const headerRegistry = createRegistry<HeaderSlot>();
